import { GREAT_WHITE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5, H7 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledRelatedFeatures = styled(H7).withConfig({
  displayName: "TrialUpgradeFeaturePanelComponents__StyledRelatedFeatures",
  componentId: "uh8zmi-0"
})(["margin:8px 24px 8px 0px;"]);
const StyledList = styled(UIList).withConfig({
  displayName: "TrialUpgradeFeaturePanelComponents__StyledList",
  componentId: "uh8zmi-1"
})(["display:flex;flex-direction:column;flex-wrap:wrap;flex:1;align-items:flex-start;height:90px;"]);
const FeatureContainer = styled(UIFlex).withConfig({
  displayName: "TrialUpgradeFeaturePanelComponents__FeatureContainer",
  componentId: "uh8zmi-2"
})(["border-left:4px solid ", ";padding:0px 16px 16px 16px;"], GREAT_WHITE);
export const PanelImage = ({
  imageKey
}) => {
  return /*#__PURE__*/_jsx(UIIllustration, {
    name: imageKey,
    width: 150,
    style: {
      minWidth: '150px'
    },
    className: "p-right-10"
  });
};
export const FeatureLink = ({
  feature,
  featureHref
}) => {
  return /*#__PURE__*/_jsx(UILink, {
    href: featureHref,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "p-right-15",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `interstitial.hc0119.features.${feature}`
    })
  }, feature);
};
export const PanelContentFeatures = ({
  features
}) => {
  return /*#__PURE__*/_jsxs(FeatureContainer, {
    align: "start",
    justify: "between",
    gap: 0,
    direction: "column",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx(StyledRelatedFeatures, {
      "aria-level": 4,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "interstitial.hc0119.relatedFeatures"
      })
    }), /*#__PURE__*/_jsx(StyledList, {
      children: Object.entries(features).map(([feature, href]) => {
        return /*#__PURE__*/_jsx(FeatureLink, {
          feature: feature,
          featureHref: href
        }, feature);
      })
    })]
  });
};
export const PanelContent = ({
  title,
  subtitle,
  features
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "start",
    justify: "start",
    gap: 0,
    direction: "column",
    children: [/*#__PURE__*/_jsx(H5, {
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: subtitle
      })
    }), /*#__PURE__*/_jsx(PanelContentFeatures, {
      features: features
    })]
  });
};